import { normalizePathname, getBaseProductRoute } from './productNavigation';

export const BREADCRUMBS = {
  '/car-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Car Insurance' },
  ],
  '/funeral-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Funeral Insurance' },
  ],
  '/life-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Life Insurance' },
  ],
  '/medical-aid-quote': [
    { label: 'Home', href: '/' },
    { label: 'Health', href: '/health' },
    { label: 'Medical Aid' },
  ],
  '/pet-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Pet Insurance' },
  ],
  '/motor-warranty': [
    { label: 'Home', href: '/' },
    { label: 'Motor', href: '/motor/' },
    { label: 'Motor Warranty' },
  ],
  '/dents-and-scratches-quote': [
    { label: 'Home', href: '/' },
    { label: 'Motor', href: '/motor/' },
    { label: 'Scratch and Dent Cover' },
  ],
  '/travel-insurance': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Travel Insurance' },
  ],
  '/medical-gap-cover-quote': [
    { label: 'Home', href: '/' },
    { label: 'Health', href: '/health' },
    { label: 'Gap Cover' },
  ],
  '/medical-insurance-quotes': [
    { label: 'Home', href: '/' },
    { label: 'Health', href: '/health' },
    { label: 'Medical Insurance' },
  ],
  '/buildings-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Buildings Insurance' },
  ],
  '/business-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance' },
  ],
  '/service-plan-quotes': [
    { label: 'Home', href: '/' },
    { label: 'Motor', href: '/motor/' },
    { label: 'Service Plans' },
  ],
  '/vehicle-tracking-quote': [
    { label: 'Home', href: '/' },
    { label: 'Motor', href: '/motor/' },
    { label: 'Vehicle Tracking' },
  ],
  '/tyre-and-rim-guard': [
    { label: 'Home', href: '/' },
    { label: 'Motor', href: '/motor/' },
    { label: 'Tyre and Rim Cover' },
  ],
  '/compare-fibre-deals': [
    { label: 'Home', href: '/' },
    { label: 'Internet', href: '/internet' },
    { label: 'Home Fibre Deals' },
  ],
  '/motorcycle-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Motorbike Insurance' },
  ],
  '/home-insurance-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Home Contents Insurance' },
  ],
  '/personal-loans': [
    { label: 'Home', href: '/' },
    { label: 'Money', href: '/money/' },
    { label: 'Personal Loans' },
  ],
  '/debt-counselling': [
    { label: 'Home', href: '/' },
    { label: 'Money', href: '/money/' },
    { label: 'Debt Counselling' },
  ],
  '/debt-consolidation-loans': [
    { label: 'Home', href: '/' },
    { label: 'Money', href: '/money/' },
    { label: 'Debt Consolidation Loans' },
  ],
  '/business-insurance-quote/car-and-commercial-property-insurance': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance', href: '/business-insurance-quote' },
    { label: 'Car & Commercial Property Insurance' },
  ],
  '/employee-benefits-quote': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance', href: '/business-insurance-quote' },
    { label: 'Employee Benefits' },
  ],
  '/business-insurance-quote/business-legal-cover': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance', href: '/business-insurance-quote' },
    { label: 'Business Legal Cover' },
  ],
  '/business-insurance-quote/professional-liability-insurance-cover': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance', href: '/business-insurance-quote' },
    { label: 'Professional Liability Insurance' },
  ],
  '/business-insurance-quote/event-liability-insurance': [
    { label: 'Home', href: '/' },
    { label: 'Insurance', href: '/insurance/' },
    { label: 'Business Insurance', href: '/business-insurance-quote' },
    { label: 'Event Liability Cover' },
  ],
  '/insurance': [{ label: 'Home', href: '/' }, { label: 'Insurance' }],
  '/motor': [{ label: 'Home', href: '/' }, { label: 'Motor' }],
  '/health': [{ label: 'Home', href: '/' }, { label: 'Health' }],
  '/money': [{ label: 'Home', href: '/' }, { label: 'Money' }],
  '/internet': [{ label: 'Home', href: '/' }, { label: 'Internet' }],
};

// Fallback label formatter for slugs that don't have a known title yet
// (e.g. an un-fetched Contentful heading). Mirrors scripts/generate-sitemap.js.
const slugToLabel = (slug = '') =>
  slug
    .replace(/-quote\d*$/, '')
    .replace(/-quotes?$/, '')
    .split('-')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

// Resolves breadcrumbs for any URL, including nested blog/spin-off pages that
// aren't explicitly listed in BREADCRUMBS above. It walks up to the nearest
// known parent route (e.g. /car-insurance-quote for
// /car-insurance-quote/premiums-by-age/) then adds one crumb per remaining
// URL segment, however deep — so
// /car-insurance-quote/south-african-car-guide/chery/chery-cross/ becomes
// Car Insurance > South African Car Guide > Chery > Chery Cross, each level
// linking to its own page. Intermediate segments are labeled from the slug
// itself (title-cased); only the final segment uses `currentLabel` (e.g. a
// Contentful page heading) when provided.
//
// Standalone dynamic pages (e.g. partner pages living at a top-level slug
// with no matching product route, like /some-partner-name/) have no known
// parent to walk up to — those still get a Home > <page title> breadcrumb
// rather than none at all.
export const getBreadcrumbs = (pathname, currentLabel) => {
  const normalized = normalizePathname(pathname);

  if (BREADCRUMBS[normalized]) return BREADCRUMBS[normalized];

  const baseRoute = getBaseProductRoute(normalized);
  const hasKnownParent = Boolean(BREADCRUMBS[baseRoute]);
  const parentCrumbs = hasKnownParent
    ? BREADCRUMBS[baseRoute]
    : [{ label: 'Home', href: '/' }];

  const baseSegments = hasKnownParent
    ? baseRoute.split('/').filter(Boolean)
    : [];
  const allSegments = normalized.split('/').filter(Boolean);
  const remainingSegments = allSegments.slice(baseSegments.length);
  if (!remainingSegments.length) return parentCrumbs;

  const trailingCrumbs = remainingSegments.map((segment, index) => {
    const isLast = index === remainingSegments.length - 1;
    const href = `/${[
      ...baseSegments,
      ...remainingSegments.slice(0, index + 1),
    ].join('/')}`;

    if (!isLast) return { label: slugToLabel(segment), href };

    const label =
      String(currentLabel || '')
        .replace(/\n/g, ' ')
        .trim() || slugToLabel(segment);
    return { label };
  });

  return [
    ...parentCrumbs.map((crumb, index) =>
      hasKnownParent && index === parentCrumbs.length - 1
        ? { ...crumb, href: baseRoute }
        : crumb
    ),
    ...trailingCrumbs,
  ];
};
